{
	"event": "Evento",
	"logout": "Cerrar sesión",
	"org": "Organización",
	"place": "Lugar",
	"language": "Idioma"
}
